var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container d-flex align-items-center justify-content-center",staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center p-5"},[_c('h1',[_c('a',{attrs:{"href":_vm.getLinkedInURL()}},[_vm._v("Authenticate LinkedIn")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90840916","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/LinkedInCompanyAuthorization.vue
// module id = null
// module chunks = 